import { useState } from "react";
import { Button } from "./ui/button";

const ROICalculator = () => {
  const [wage, setWage] = useState("18");
  const [hours, setHours] = useState("4");
  const [days, setDays] = useState("6");
  
  const [weekly, setWeekly] = useState(432);
  const [monthly, setMonthly] = useState(1871);
  const [annual, setAnnual] = useState(22464);

  const formatMoney = (n: number) => {
    return isFinite(n) ? `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}` : "$0";
  };

  const calculate = () => {
    const w = parseFloat(wage) || 0;
    const h = parseFloat(hours) || 0;
    const d = parseFloat(days) || 0;

    const weeklyCalc = w * h * d;
    const monthlyCalc = weeklyCalc * 4.33;
    const annualCalc = monthlyCalc * 12;

    setWeekly(weeklyCalc);
    setMonthly(monthlyCalc);
    setAnnual(annualCalc);
  };

  return (
    <div 
      className="rounded-xl p-4 md:p-5 border border-[hsl(var(--line))] hover:border-primary/30 transition-all duration-500 animate-fade-in"
      style={{
        background: "linear-gradient(180deg, hsl(var(--glass)), hsl(0 0% 100% / 0.03))",
        boxShadow: "0 4px 20px rgba(0,0,0,0.2), inset 0 0 40px hsl(var(--primary) / 0.05)"
      }}
    >
      <h3 className="text-lg md:text-xl font-bold mb-2 font-orbitron">ROI in 30 Seconds</h3>
      <p className="text-sm mb-3.5" style={{ color: "#dce7ff" }}>
        Estimate labor savings vs. robot cost. Instant, no email required.
      </p>

      <div className="space-y-2.5">
        <div>
          <label className="block mb-1.5 font-semibold text-sm">Hourly wage ($)</label>
          <input
            type="number"
            inputMode="decimal"
            placeholder="18"
            value={wage}
            onChange={(e) => setWage(e.target.value)}
            className="w-full px-3 py-2.5 rounded-lg border border-[hsl(var(--line))] bg-[hsl(var(--input))] text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          />
        </div>

        <div>
          <label className="block mb-1.5 font-semibold text-sm">Hours per day saved</label>
          <input
            type="number"
            inputMode="decimal"
            placeholder="4"
            value={hours}
            onChange={(e) => setHours(e.target.value)}
            className="w-full px-3 py-2.5 rounded-lg border border-[hsl(var(--line))] bg-[hsl(var(--input))] text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          />
        </div>

        <div>
          <label className="block mb-1.5 font-semibold text-sm">Days per week</label>
          <input
            type="number"
            inputMode="numeric"
            placeholder="6"
            value={days}
            onChange={(e) => setDays(e.target.value)}
            className="w-full px-3 py-2.5 rounded-lg border border-[hsl(var(--line))] bg-[hsl(var(--input))] text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          />
        </div>

        <div className="flex gap-2.5 flex-wrap pt-1.5">
          <Button 
            onClick={calculate} 
            className="bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 font-bold transition-all duration-300"
          >
            Calculate
          </Button>
          <Button 
            variant="outline" 
            asChild
            className="glass-effect border-[hsl(var(--line))] hover:bg-white/10 hover:border-primary/50 transition-all duration-300"
          >
            <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
              Get Custom Proposal
            </a>
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mt-3.5">
        <div className="border border-[hsl(var(--line))] rounded-xl bg-white/5 hover:bg-white/8 p-2.5 text-center transition-all duration-300 hover:border-primary/40">
          <div className="text-[0.65rem] opacity-85 mb-1">Weekly Savings</div>
          <div className="text-lg md:text-xl font-black">{formatMoney(weekly)}</div>
        </div>
        <div className="border border-[hsl(var(--line))] rounded-xl bg-white/5 hover:bg-white/8 p-2.5 text-center transition-all duration-300 hover:border-primary/40">
          <div className="text-[0.65rem] opacity-85 mb-1">Monthly Savings</div>
          <div className="text-lg md:text-xl font-black">{formatMoney(monthly)}</div>
        </div>
        <div className="border border-[hsl(var(--line))] rounded-xl bg-white/5 hover:bg-white/8 p-2.5 text-center transition-all duration-300 hover:border-primary/40">
          <div className="text-[0.65rem] opacity-85 mb-1">Annual Savings</div>
          <div className="text-lg md:text-xl font-black">{formatMoney(annual)}</div>
        </div>
      </div>

      <p className="text-xs mt-2 opacity-90" style={{ color: "#cfe1ff" }}>
        Estimates only. Book a demo for a site-specific quote.
      </p>
    </div>
  );
};

export default ROICalculator;
